import { SurfaceTextMap, TextElement } from '@/types/personalization';
import {
	DEFAULT_TEXT_ALIGN,
	DEFAULT_TEXT_COLOR,
	DEFAULT_TEXT_FONT,
	DEFAULT_TEXT_FONT_SIZE,
} from '@/data/textFormatting';

type TextElementInput = Partial<Omit<TextElement, 'id' | 'surfaceId'>> &
	Pick<TextElement, 'id' | 'surfaceId'>;

export const ensureTextElementDefaults = (element: TextElementInput): TextElement => ({
	id: element.id,
	surfaceId: element.surfaceId,
	content: element.content ?? 'Nowy tekst',
	position: element.position ?? { x: 0.5, y: 0.5 },
	layerIndex: element.layerIndex ?? -1,
	fontSize: element.fontSize ?? DEFAULT_TEXT_FONT_SIZE,
	fontFamily: element.fontFamily ?? DEFAULT_TEXT_FONT,
	isBold: element.isBold ?? false,
	isItalic: element.isItalic ?? false,
	color: element.color ?? DEFAULT_TEXT_COLOR,
	align: element.align ?? DEFAULT_TEXT_ALIGN,
	rotation: element.rotation ?? 0,
	repeatGroupId: element.repeatGroupId,
	repeatIndex: element.repeatIndex,
});

export const createTextElement = (
	overrides: Partial<TextElementInput> & Pick<TextElement, 'surfaceId'>
): TextElement => {
	const id = overrides.id ?? globalThis.crypto?.randomUUID?.() ?? `text-${Date.now()}`;
	return ensureTextElementDefaults({
		...overrides,
		id,
	});
};

export const cloneSurfaceTextMap = (map: SurfaceTextMap): SurfaceTextMap =>
	Object.fromEntries(
		Object.entries(map).map(([surfaceId, elements]) => [
			surfaceId,
			elements.map((element, index) =>
				ensureTextElementDefaults({
					...element,
					layerIndex: element.layerIndex ?? index,
				})
			),
		])
	);
